/**
 * Avatar utility functions for building avatar src URLs and initials.
 */

/**
 * Returns the best avatar image URL for a user.
 * Fallback chain: uploaded file / Google OAuth picture → undefined (MUI shows initials).
 */
export function getAvatarSrc(photoUrl?: string): string | undefined {
  if (photoUrl) return photoUrl;
  return undefined;
}

/**
 * Returns initials for display inside an Avatar when no image is available.
 */
export function getInitials(displayName?: string, name?: string, email?: string): string {
  const n = displayName || name || email || '';
  return n.charAt(0).toUpperCase();
}
